import { render } from "./ShowMenuMesas.vue?vue&type=template&id=23fb6884"
import script from "./ShowMenuMesas.vue?vue&type=script&lang=js"
export * from "./ShowMenuMesas.vue?vue&type=script&lang=js"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__